const SESSION_DISMISS_KEY = 'aaa_email_verify_reminder_dismiss_session_v1';

/** Unverified sign-in email — show soft reminders (does not gate access). */
export function shouldShowEmailVerificationReminder(user) {
    return Boolean(user && user.emailVerified !== true);
}

export function isEmailVerificationReminderDismissedThisSession() {
    try {
        return sessionStorage.getItem(SESSION_DISMISS_KEY) === '1';
    } catch {
        return false;
    }
}

export function dismissEmailVerificationReminderThisSession() {
    try {
        sessionStorage.setItem(SESSION_DISMISS_KEY, '1');
    } catch {
        /* storage blocked */
    }
}

/** Call when user verifies so a future login starts without stale dismiss concern. */
export function clearEmailVerificationReminderSessionDismiss() {
    try {
        sessionStorage.removeItem(SESSION_DISMISS_KEY);
    } catch {
        /* noop */
    }
}
